import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import ShowData from "../../components/summary/showData";
import curri from "../../constants/enum/curriSum";
const curriContext = React.createContext({});
const Summary = () => {
  const [keyStatus, setKeyStatud] = useState(true);
  const [loadStatus, setLoadStatus] = useState(false);
  const [showData, setShowData] = useState(false);
  const [typeSelect, setTypeSelect] = useState("");
  const [reCheck, setReCheck] = useState(false);
  // const me = useSelector((state: any) => state.me);
  const [form, setForm] = useState<{
    type: string;
    year: string;
    term: string;
  }>({ type: "", year: "", term: "" });

  const [curriList, setCurriList] = useState<
    {
      id: number;
      level: string;
      degreeName: string;
      name: string;
      shortName: string;
    }[]
  >([]);
  useEffect(() => {
    (async () => {
      if (typeSelect.substring(0, 1) === "t") {
        setCurriList(curri.tqf);
      } else if (typeSelect.substring(0, 1) === "m") {
        setCurriList(curri.mhesi);
      } else {
        setCurriList([]);
      }
    })();
  }, [typeSelect]);

  const findSchema = Yup.object().shape({
    type: Yup.string().required("เลือกประเภทเอกสารที่ต้องการก่อนครับ"),
    year: Yup.string().required("ระบุปีการศึกษาด้วยครับ (พ.ศ.)"),
    term: Yup.string().required("เลือกเทอมที่ต้องการด้วยครับ"),
  });

  const onSubmit = (values: { type: string; year: string; term: string }) => {
    setKeyStatud(false);
    setLoadStatus(true);
    setShowData(false);
    setForm(values);

    setTimeout(() => {
      setLoadStatus(false);
      setShowData(true);
    }, 1000);
    // console.log(values);
  };

  return (
    <curriContext.Provider value={{ reCheck, setReCheck }}>
      <div className="container">
        <h3 className="text-start mt-3">แบบสรุป อชว. | มคอ.</h3>
        <div className="row p-3 mb-4 bg-light rounded-4">
          <div className="row">
            <Formik
              validationSchema={findSchema}
              initialValues={{ type: "", year: "", term: "" }}
              onSubmit={onSubmit}
            >
              {({ handleBlur, handleChange, values, errors, touched }) => (
                <Form>
                  <div className="row">
                    <div className="col"></div>
                    <div className="col-md-3">
                      <select
                        name="type"
                        value={values.type}
                        onChange={(e) => {
                          handleChange(e);
                          setKeyStatud(true);
                          setShowData(false);
                          setTypeSelect(e.target.value);
                        }}
                        onBlur={handleBlur}
                        placeholder={"ประเภทเอกสาร"}
                        className={`form-select ${
                          touched.type
                            ? errors.type
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                        }`}
                        aria-label="Default select example"
                      >
                        <option selected value="">
                          ประเภทเอกสาร
                        </option>
                        <option value="mhesi3">แบบสรุป อชว.3-4</option>
                        <option value="mhesi5">แบบสรุป อชว.5-6</option>
                        <option value="tqf3">แบบสรุป มคอ.3-4</option>
                        <option value="tqf5">แบบสรุป มคอ.5-6</option>
                      </select>
                      <ErrorMessage
                        name="type"
                        className="invalid-feedback"
                        component="div"
                      />
                    </div>
                    <div className="col-md-2">
                      <Field
                        type="text"
                        value={values.year}
                        onChange={(e: string) => {
                          handleChange(e);
                          setKeyStatud(true);
                          setShowData(false);
                        }}
                        className={`form-control ${
                          touched.year
                            ? errors.year
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                        }`}
                        name="year"
                        placeholder="ปีการศึกษา"
                      />
                      <ErrorMessage
                        name="year"
                        className="invalid-feedback"
                        component="div"
                      />
                    </div>
                    <div className="col-md-2">
                      <select
                        name="term"
                        value={values.term}
                        onChange={(e) => {
                          handleChange(e);
                          setKeyStatud(true);
                          setShowData(false);
                        }}
                        className={`form-select ${
                          touched.term
                            ? errors.term
                              ? "is-invalid"
                              : "is-valid"
                            : ""
                        }`}
                        onBlur={handleBlur}
                        aria-label="Default select example"
                      >
                        <option selected value="">
                          ภาคการศึกษาที่
                        </option>
                        <option value="1">ภาคการศึกษาที่ 1</option>
                        <option value="2">ภาคการศึกษาที่ 2</option>
                        <option value="3">ภาคการศึกษาฤดูร้อน</option>
                      </select>
                      <ErrorMessage
                        name="term"
                        className="invalid-feedback"
                        component="div"
                      />
                    </div>
                    <div className="col-md-2">
                      <button className="btn btn-success col-12" type="submit">
                        ค้นหา
                      </button>
                    </div>
                    <div className="col"></div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <hr />

        {/* //   กรณีเพิ่งเปิดเข้ามาและกำลังเลือกข้อมูล   // */}
        {keyStatus && (
          <div className="row alert alert-warning" role="alert">
            <h3>เลือกข้อมูลที่ต้องการแล้วกด ค้นหา</h3>
          </div>
        )}

        {/* //   กรณีกำลัง load ข้อมูล   // */}
        {loadStatus && (
          <div className="row alert alert-warning" role="alert">
            <div className="d-flex justify-content-center">
              <div className="spinner-border" role="status"></div>
              <h3 className="ms-2"> Loading...</h3>
            </div>
          </div>
        )}

        {showData && <ShowData curri={curriList} form={form} />}
      </div>
    </curriContext.Provider>
  );
};

export { curriContext };
export default Summary;
